import { Routes } from '@angular/router';
import { PlantComponent } from './plant/plant.component';
import { LineMangerComponent } from './plant/lines/line-manger/line-manger.component';
import { PlantManagerComponent } from './plant/plant-manager/plant-manager.component';
import { EquipmentComponent } from './plant/equipment/equipment.component';
import { EquipmentManagerComponent } from './plant/equipment/equipment-manager/equipment-manager.component';
import { LinesComponent } from './plant/lines/lines.component';
import { GeaMesLoginComponent, GeaMesCognitoAuthGuard } from '@gea-mes/cognito';
import { SublinesComponent } from './plant/lines/line-manger/sublines/sublines.component';
import { SublineManagerComponent } from './plant/lines/line-manger/sublines/subline-manager/subline-manager.component';
import { DeltaComponent } from './plant/subAssemblyDelta/delta.component';
import { DeltaManagerComponent } from './plant/subAssemblyDelta/delta-manager/delta-manager.component';
import { LogOutPageComponent } from './log-out-page/log-out-page.component';

export const routes: Routes = [
  { path: 'login', component: GeaMesLoginComponent },
  { path: 'logout', component: LogOutPageComponent },
  {
    path: '',
    canActivate: [GeaMesCognitoAuthGuard],
    children: [
      { path: 'plants', component: PlantComponent },
      { path: 'create-plant', component: PlantManagerComponent, data: { type: 'create' } },
      { path: 'update-plant', component: PlantManagerComponent, data: { type: 'update' } },
      { path: 'lines', component: LinesComponent },
      { path: 'create-line', component: LineMangerComponent, data: { type: 'create' } },
      { path: 'update-line', component: LineMangerComponent, data: { type: 'update' } },
      { path: 'equipment', component: EquipmentComponent },
      { path: 'create-equipment', component: EquipmentManagerComponent, data: { type: 'create' } },
      { path: 'update-equipment', component: EquipmentManagerComponent, data: { type: 'update' } },
      { path: 'sublines', component: SublinesComponent },
      { path: 'create-subline', component: SublineManagerComponent, data: { type: 'create' } },
      { path: 'update-subline', component: SublineManagerComponent, data: { type: 'update' } },
      { path: 'subassemblydelta', component: DeltaComponent },
      { path: 'create-valueConfig', component: DeltaManagerComponent, data: { type: 'create', content: 'valueconfig' } },
      { path: 'update-valueConfig', component: DeltaManagerComponent, data: { type: 'update', content: 'valueconfig' } },
      { path: 'create-columnConfig', component: DeltaManagerComponent, data: { type: 'create', content: 'columnconfig' } },
      { path: 'update-columnConfig', component: DeltaManagerComponent, data: { type: 'update', content: 'columnconfig' } }
    ]
  },
  { path: '**', redirectTo: '/plants' }
];